import { type FC } from 'react';
import { TObjectDeleteJob } from 'types/objectJob.type';
import DeleteJobExecutionResult from './DeleteJobExecutionResult';
import JobDetailHeader from './JobDetailHeader';
import OperationInfo from './OperationInfo';

type Props = {
  data: TObjectDeleteJob;
};

const DeleteDetails: FC<Props> = ({ data }: Props) => {
  return (
    <>
      <JobDetailHeader job={data} newOperationButton={null} />
      <OperationInfo job={data} />
      <DeleteJobExecutionResult job={data} />
    </>
  );
};

export default DeleteDetails;
